import { Inject, Injectable, InjectionToken } from '@angular/core';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { catchError, filter, from, map, of, switchMap, take, timeout } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@okta/okta-angular";
/**
 * Default resolver when there is no identity source for async LD context.
 */
export class NoopFeatureFlagUserResolver {
    resolveLaunchDarklyContext() {
        return of(null);
    }
    static { this.ɵfac = function NoopFeatureFlagUserResolver_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NoopFeatureFlagUserResolver)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NoopFeatureFlagUserResolver, factory: NoopFeatureFlagUserResolver.ɵfac }); }
}
export const WebAngularSharedUtilOktaFeatureFlagUserContext = new InjectionToken('WebAngularSharedUtilOktaFeatureFlagUserContext');
export class OktaFeatureFlagUserContext {
    constructor(oktaAuth, oktaAuthStateService) {
        this.oktaAuth = oktaAuth;
        this.oktaAuthStateService = oktaAuthStateService;
    }
    resolveLaunchDarklyContext() {
        return from(this.oktaAuth.getUser()).pipe(take(1), switchMap((user) => {
            if (user) {
                return of(this.toLdContext(user));
            }
            return this.waitForAuthenticatedUser();
        }), catchError(() => this.waitForAuthenticatedUser()));
    }
    waitForAuthenticatedUser() {
        return this.oktaAuthStateService.authState$.pipe(filter((state) => !!state?.isAuthenticated), switchMap(() => from(this.oktaAuth.getUser())), take(1), timeout(10000), map((user) => this.toLdContext(user)), catchError(() => of(null)));
    }
    toLdContext(user) {
        if (!user) {
            return null;
        }
        const userKey = user.email || user.sub || user.preferred_username;
        if (!userKey) {
            return null;
        }
        return {
            kind: 'user',
            key: userKey,
            name: user.name || user.preferred_username || userKey,
            email: user.email
        };
    }
    static { this.ɵfac = function OktaFeatureFlagUserContext_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || OktaFeatureFlagUserContext)(i0.ɵɵinject(OKTA_AUTH), i0.ɵɵinject(i1.OktaAuthStateService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: OktaFeatureFlagUserContext, factory: OktaFeatureFlagUserContext.ɵfac }); }
}
//# sourceMappingURL=okta-feature-flag-user-context.js.map